import { render, staticRenderFns } from "./GerenciaCadastroPessoas.vue?vue&type=template&id=2b5eb3c3"
import script from "./GerenciaCadastroPessoas.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroPessoas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports